defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PostCard',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
  ],
  function (m) {
    // Context:
    var PostCard = function ({ className, icon, type, title, description, $header, $footer, keyIndex }) {
      const _className = () => {
        let name = '';
        if (type) {
          name += ` play-together__post-card--${type}`;
        }

        if (className) {
          name += ` ${className}`;
        }

        return name;
      };
      // Return:
      return m('.play-together__post-card', {
        class: _className(),
        key: keyIndex
      }, [
        icon ? m('.post-card__icon',
          m(`svg.${icon}-icon`,
            m('use', {
              href: `/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#${icon}`
            })
          )
        ) : null,
        $header ? m('.play-together__post-card-header', $header) : null,
        title || description ? m('.play-together__post-card-inner', [
          title ? m('.post-card__title', title) : null,
          description ? m('.post-card__description', m.trust(description)) : null
        ]) : null,
        $footer ? m('.post-card__footer', $footer) : null
      ]);
    };

    // Public functions:
    return PostCard;
  });
